import {
  gspx,
  GPX_EVENT_TYPES,
  GPX_FEATURES,
  GPX_CAPABILITIES,
  GPX_ROUTES,
} from '@rsos/gainsight';

// Event names for Text-to-Voice Translation tracking
const TEXT_TO_VOICE_EVENT_NAMES = {
  INVOKED: 'text_to_voice_translation_invoked',
} as const;

interface TrackTextToVoiceInvokedParams {
  /**
   * The list of detected language codes being translated (e.g., ['es'], ['zh', 'en'])
   */
  detectedLanguages: string[];
  /**
   * The language currently selected/active at the time TTVT is triggered.
   * This is the manual selection if set, otherwise the first detected language.
   */
  selectedLanguage: string | null;
}

/**
 * Tracks when Text-to-Voice Translation (TTVT) is invoked by a user.
 * Note: The PSAP account_id is automatically captured by the gainsight library
 * via ecc_account_ids from the data provider.
 * @param params - The parameters for tracking the TTVT invocation
 * @param params.detectedLanguages - The list of detected language codes being translated
 * @param params.selectedLanguage - The language currently selected at invocation time
 */
export const trackTextToVoiceInvoked = ({
  detectedLanguages,
  selectedLanguage,
}: TrackTextToVoiceInvokedParams): void => {
  gspx.trackEvent({
    name: TEXT_TO_VOICE_EVENT_NAMES.INVOKED,
    type: GPX_EVENT_TYPES.CLICK,
    feature: GPX_FEATURES.TEXT_TO_VOICE_TRANSLATION,
    capability: GPX_CAPABILITIES.TEXT_TO_VOICE_TRANSLATION,
    route: GPX_ROUTES.EVENT_PANE,
    entities: {
      detected_languages: detectedLanguages,
      selected_language: selectedLanguage,
    },
  });
};
